import React, { useCallback, useState } from 'react';
import SaveAnalysisModal, {
  useUrlAnalysisSave,
} from '../../component/SaveAnalysisModal';
import { useFilterGptInfo } from '../../hook';
import { PromptConfirmItemType } from '@op/components/GPT/types';
import { DBO_TM } from '@op/utils/format';
import URLCard from './URLCard';
import Filter from '../../component/Filter';
import {
  ChangeFilterPropsType,
  GPTContentType,
  PromptKeyType,
} from '../../types';
import '../../scss/analysisCard.scss';

interface ICreateAnalysis {
  userInfo: any;
  gameInfo: any;
  wholeGameInfo: any;
  isPreviews?: boolean;
  isCreator?: boolean;
  shortId?: string;
  leadId?: number;
  setApiLoading?: (flag: string) => void;
  backGptInfo?: (list: GPTContentType[]) => void;
  changeTab?: () => void;
  resetAnalysis?: () => Promise<any>;
  /** 隐藏筛选器底部操作按钮（确定 / 重置 / Stop），用于只读内嵌场景 */
  hideFilterOperateBtn?: boolean;
  /** 全部预览模式，预览模式下筛选器会有特殊样式调整（FilterBox: dbo-filterbox--all-preview） */
  allPreview?: boolean;
}
export default function URLCardAnalysis({
  gameInfo,
  wholeGameInfo,
  isPreviews = false,
  shortId,
  isCreator = true,
  setApiLoading,
  leadId,
  backGptInfo,
  userInfo,
  changeTab,
  resetAnalysis,
  hideFilterOperateBtn,
  allPreview,
}: ICreateAnalysis) {
  const {
    saveVisible,
    setSaveParams,
    saveUserSummary,
    updateUrlSummary,
    resetSaveId,
    saveTipsElement,
    toggleSaveWindow,
    setUpdateParams,
    saveTipsIcon,
    setSaveId,
    setIsSave,
  } = useUrlAnalysisSave({ isPreviews, changeTab, isCreator });
  const [urlTaskId, setUrlTaskId] = useState<number | undefined>();
  const [loading, setLoading] = useState(isPreviews);
  const [urlLoading, setUrlLoading] = useState(false);
  const [taskData, setTaskData] = useState<any>();

  const {
    promptInfoMap,
    changePromptInfo,
    promptList,
    videoPromptList,
    oriFilterValue,
    changeFilterValue,
    filterValue,
    tab,
    gptList,
    setGptList,
    gptListRef,
  } = useFilterGptInfo({
    gameInfo,
    wholeGameInfo,
    updateSummary: updateUrlSummary,
    setSaveParams,
    isPreviews,
    defaultTab: 'url',
  });

  function handleStop() {
    changeFilterValue(null, null, tab);
  }

  function generateAnalysisClick({
    filter,
    oriFilter,
    tab,
    pageFilter,
    promptInfo,
    gptList,
    urlTaskId,
    taskData,
    isSave,
  }: ChangeFilterPropsType) {
    changeFilterValue(filter, oriFilter, tab);
    setSaveParams((value: any) => ({ ...value, ...pageFilter }));
    promptInfo && changePromptInfo(promptInfo);
    setGptList(gptList || []);
    backGptInfo?.(gptList || []);
    setTaskData(taskData);
    const urlLeadId = isPreviews ? leadId : urlTaskId;
    setUpdateParams({ lead_id: urlLeadId });
    setUrlTaskId(urlLeadId); 
    if (isSave) {
      setSaveId(urlLeadId); 
    } 
    setIsSave(!!isSave);
  }

  const getSaveWindowsName = useCallback(() => {
    return DBO_TM.timeTitle(filterValue);
  }, [filterValue]);
  return (
    <>
      <Filter
        changeFilterValue={generateAnalysisClick}
        gameInfo={gameInfo}
        shortId={shortId}
        tab="url"
        userInfo={userInfo}
        setLoading={setLoading}
        isCreator={isCreator}
        loading={loading || urlLoading}
        promptList={promptList}
        videoPromptList={videoPromptList}
        resetSaveId={resetSaveId}
        updateUrlSummary={updateUrlSummary}
        isPreview={isPreviews}
        leadId={leadId}
        resetAnalysis={resetAnalysis}
        promptInfoMap={promptInfoMap}
        wholeGameInfo={wholeGameInfo}
        hideFilterOperateBtn={hideFilterOperateBtn}
        allPreview={allPreview}
      ></Filter>
      <URLCard
        filter={filterValue}
        gameInfo={gameInfo}
        wholeGameInfo={wholeGameInfo}
        loading={loading}
        saveTipsElement={saveTipsElement}
        isPreviews={isPreviews}
        setLoading={setUrlLoading}
        handleStop={handleStop}
        gptList={gptList!}
        gptListRef={gptListRef}
        taskId={urlTaskId}
        taskData={taskData}
        videoPromptList={videoPromptList}
        promptList={promptList}
        setApiLoading={setApiLoading}
        promptInfoMap={promptInfoMap}
        setPromptInfo={async (
          promptInfo: PromptConfirmItemType,
          key: PromptKeyType,
          paramsKey: 'video_task_id' | 'comment_task_id',
        ) => {
          let params: any = undefined;
          if (isCreator) {
            params = {
              [paramsKey]: promptInfo.taskId,
            };
          }
          return await changePromptInfo({ [key]: promptInfo }, params);
        }}
        oriFilterValue={oriFilterValue}
      ></URLCard>

      {filterValue !== null && saveTipsIcon}

      {!isPreviews && (
        <SaveAnalysisModal
          visible={saveVisible}
          wholeGameInfo={wholeGameInfo}
          saveUserSummary={saveUserSummary}
          close={() => toggleSaveWindow()}
          getSaveWindowsName={getSaveWindowsName}
        ></SaveAnalysisModal>
      )}
    </>
  );
}
